<template>
  <div class="col s12 pa-0" >
    <simple-dialog :show="mostrarSimilares" @onClose="fecharSimilares">
      <div class="similares-carrinho">
        <h4>Itens similares</h4>
        <p v-if="itemSimilarSelecionado">Alternativas para <strong>{{ itemSimilarSelecionado.sku }}</strong></p>
        <div v-if="carregandoSimilares" class="center-align pa-2"><span class="preloader-wrapper small active"><span class="spinner-layer spinner-blue-only"><span class="circle-clipper left"><span class="circle"></span></span><span class="gap-patch"><span class="circle"></span></span><span class="circle-clipper right"><span class="circle"></span></span></span></span></div>
        <div v-else class="collection">
          <div v-for="similar in similaresSelecionados" :key="similar.itemId" class="collection-item">
            <strong>{{ similar.itemSku }}</strong>
            <span>{{ similar.itemDescricao }}</span>
            <small v-if="similar.motivoSimilaridade"><b>Motivo:</b> {{ similar.motivoSimilaridade }}</small>
          </div>
        </div>
      </div>
    </simple-dialog>
    <template v-if="showCarrinho || mouseShow">
      <div
        class="card collapsible col s12 ma-0 pa-0 center right"
        style="z-index: 997;position: relative;top: 5px;right: 6px;width: 270px;height: calc(100vh - 1rem);"
      >
        <div class="ponta-balao"></div>
        <div class="col s12 pa-1">
            <h5 style="line-height: 2rem;" class="black-text valign-wrapper center-block mt-0" >
              <span v-if="resumo && resumo.itens && resumo.itens.length > 0 && listItemIdSpinner.length == 0">
                {{ resumo.itens.length }}
              </span>
              <span v-else class="pl-1 pr-1">
                <span class="preloader-wrapper small active" style="height: 20px;width: 20px;">
                  <div class="spinner-layer" style="border-color: black;">
                    <div class="circle-clipper left"><div class="circle"></div></div>
                    <div class="gap-patch"><div class="circle"></div></div>
                    <div class="circle-clipper right"><div class="circle"></div></div>
                  </div>
                </span>
              </span>
              itens
            </h5>

            <a
              href="#"
              class="btn-flat btn-floating"
              @click.prevent="fechar"
              style="position: absolute;right: 0;line-height: 2;margin-right: 0.5rem;margin-top: -44px;">
              <i class="material-icons left grey-text" style="line-height: 1.7;">close</i>
            </a>

            <h5 style="line-height: 2rem;" class="red-text">R$
              <span v-if="resumo && resumo.itens && resumo.itens.length > 0 && listItemIdSpinner.length == 0"">
                {{ resumo.subtotal | grana }}
              </span>
              <span v-else class="pl-1 pr-1">
                <span class="preloader-wrapper small active" style="height: 20px;width: 20px;">
                  <div class="spinner-layer" style="border-color: red;">
                    <div class="circle-clipper left"><div class="circle"></div></div>
                    <div class="gap-patch"><div class="circle"></div></div>
                    <div class="circle-clipper right"><div class="circle"></div></div>
                  </div>
                </span>
              </span>
            </h5>

            <a
              v-if="resumo && resumo.itens && resumo.itens.length > 0"
              class="col s12 waves-effect waves-light btn white-text pr-1 pl-1"
              @click.prevent="$router.push({path:'unit039'})">
              Ver Carrinho
            </a>
            <a
              v-else
              class="col s12 waves-effect waves-light btn white-text pr-1 pl-1"
              @click.prevent="$router.push({path:'unit005'})">
              Ver Produtos
            </a>
            <a @click.prevent="removeTodos" class="col s12 btn btn-flat waves-effect waves-light mt-1 pr-1 pl-1">
              Remover todos
            </a>
        </div>
  
        <div class="divider col s12 pa-0" />
  
        <div
          style="overflow: scroll;height: calc(100% - 200px);"
          class="col s12 ma-0 pa-0 pl-1 pr-1 black-text"
          v-if="resumo && resumo.itens && resumo.itens.length > 0"
        >
          <div v-for="(item, index) in resumo.itens" :key="index">
            <CardProduto
              :item="item"
              :ordem="index+1"
              :listItemIdSpinner="listItemIdSpinner"
              :temSimilar="exibirIconeSimilar(item)"
              @onAddItem="addItem"
              @defineQtd="defineQtd"
              @onRemoveItem="removeItem"
              @onRemoverQuantidadeItem="removerQuantidadeItem"
              @onVerSimilares="verSimilares"
            />
          </div>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
import CardProduto from './CardProduto.vue';
import StHelper from '../../helpers/StHelper.js';
import ServiceFactory from '../../services/ServiceFactory.js';
import SimpleDialog from '../dialog/SimpleDialog.vue';

export default {
  name:'carrinho-view',
  components: {
    CardProduto,
    SimpleDialog,
  },
  props:{
    idPedido: null,
    showCarrinho: false,
    mouseShow: false,
    env: { type: Object, required: true },
  },
  data () {
    return {
      resumo: null,
      qtd: 1,
      carrinhoService: null,
      pedidoCorrente: null,
      listItemIdSpinner: [],
      idsComSimilares: [],
      mostrarSimilares: false,
      carregandoSimilares: false,
      itemSimilarSelecionado: null,
      similaresSelecionados: [],
    }
  },
  created () {
    this.loadResources();
  },
  methods: {
    loadResources() {
      const sf = new ServiceFactory(this.$http);
    sf.carrinho()
    .then(serv => this.carrinhoService = serv)
    .catch(e => this.modalError = e);
    },
    addItem(item) {
      if(!item) return;

      this.listItemIdSpinner.push(item.itemId);
      this.$http.put(`carrinho/v2/${item.itemId}`, item.quantidadeMultipla)
        .then(rs => rs.json())
        .then(result => {
            if (result.message) 
              StHelper.toastAlertaPositive(result.message);
            
        })
        .catch(e => this.$emit('onError',e))
        .finally(() => this.getSubtotal(item));
    },
    removerQuantidadeItem(item) {
      if(!item) return;

      this.listItemIdSpinner.push(item.itemId);
      this.$http.put(`carrinho/v2/${item.itemId}`, (item.quantidadeMultipla * -1))
        .then(rs => rs.json())
        .then(result => result.message && StHelper.toastAlertaPositive(result.message))
        .catch(e => this.$emit('onError',e))
        .finally(() => this.getSubtotal(item));
    },
    defineQtd(qtd) {
      this.qtd = qtd;
      this.$emit('defineQtd', qtd);
    },
    removeItem(item) {
      if(!item) return;

      this.removerItem(item);
    },
    getSubtotal(item = {itemId: 0}) {
      if(!this.idPedido || !item) return;

      this.listItemIdSpinner.push(item.itemId);
      this.$http.put(`carrinho/totalizar/${this.idPedido}`)
        .then(() => this.$http.get(`carrinho/subtotal/${this.idPedido}`))        
        .then(response => response.json())
        .then(resumo => this.resumo = resumo)
        .then(() => this.carregarDisponibilidadeSimilares())
        .then(() => this.$emit('defineQtd', this.resumo.countItensPedido))
        .then(() => this.$http.put(`carrinho/${this.idPedido}/removerItensSemTabelaPreco`))
        .then(res => res.json())
        .then(rs => rs.forEach(msg => StHelper.toastAlerta(msg)))
        .then(() => this.carrinhoService.obtemPedidoCompleto(this.pedcId))
        .then(pedido => this.pedidoCorrente = pedido)
        .catch(e => this.modalError = e)
        .then(() => this.listItemIdSpinner = this.listItemIdSpinner.filter(id => id != item.itemId));
    },
    removerItem(item) {
      if(!item) return;

      this.listItemIdSpinner.push(item.itemId);
      this.$http.delete(`carrinho/${item.pedcId}/detalhe/${item.peddId}`)
        .catch(e => this.modalError = e)
        .finally(() => this.getSubtotal(item));
    },
    fechar() {
      this.$emit('fechar');
    },
    removeTodos() {
      const peddIds = this.resumo.itens.map(item => item.peddId).join(',');
      const pedcId = this.resumo.pedcId;
      this.$emit('onRemoveTodos', pedcId, peddIds);
    },
    carregarDisponibilidadeSimilares() {
      if (!this.env.exibir_icone_similares_carrinho || !this.resumo || !this.resumo.itens) {
        this.idsComSimilares = [];
        return Promise.resolve();
      }
      const ids = this.resumo.itens.map(item => item.itemId);
      if (!ids.length) { this.idsComSimilares = []; return Promise.resolve(); }
      return this.$http.post('itemSimilar/disponibilidade', ids)
        .then(response => response.json())
        .then(resultado => { this.idsComSimilares = resultado || []; })
        .catch(e => { this.idsComSimilares = []; this.$emit('onError', e); });
    },
    exibirIconeSimilar(item) {
      return this.env.exibir_icone_similares_carrinho === true && this.idsComSimilares.indexOf(item.itemId) >= 0;
    },
    verSimilares(item) {
      this.itemSimilarSelecionado = item;
      this.similaresSelecionados = [];
      this.mostrarSimilares = true;
      this.carregandoSimilares = true;
      this.$http.get(`itemSimilar/resumo/${item.itemId}`)
        .then(response => response.json())
        .then(resultado => {
          const skuOrigem = item.sku != null ? String(item.sku).trim().toUpperCase() : '';
          this.similaresSelecionados = (resultado || []).filter(similar => {
            const skuSimilar = similar.itemSku != null ? String(similar.itemSku).trim().toUpperCase() : '';
            return !skuOrigem || skuSimilar !== skuOrigem;
          });
        })
        .catch(e => this.$emit('onError', e))
        .then(() => { this.carregandoSimilares = false; });
    },
    fecharSimilares() {
      this.mostrarSimilares = false;
      this.itemSimilarSelecionado = null;
      this.similaresSelecionados = [];
    },
  }
}
</script>

<style lang="scss" scope>

  .ponta-balao {
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-color: transparent transparent #fff transparent;
    top: 2px;
    left: 0;
    transform: translateY(0) rotate(45deg);
    border-width: 20px 20px 20px 0;
  }

  .similares-carrinho .collection-item { display: flex; flex-direction: column; gap: 3px; }
  .similares-carrinho .collection-item strong { color: #1565c0; }
  .similares-carrinho .collection-item small { margin-top: 4px; color: #607d8b; }

</style>





// WEBPACK FOOTER //
// CarrinhoView.vue?cdc81652